import(/* webpackMode: "eager" */ "/runner/_work/hotline/hotline/frontend/src/app/page.tsx");
